import { styled } from "@mui/material/styles";
import { Grid } from "@mui/material";

export const StyledContainer = styled("div")(({ theme }) => ({
  backgroundColor: theme.palette.common.background.light,
  border: "1px solid grey",
  overflow: "auto",
  position: "fixed",
  top: 130,
  bottom: 65,
  left: 110,
  right: 120
}));

export const StyledHeader = styled("div")(({ theme }) => ({
  backgroundColor: theme.palette.primary.light,
  color: theme.palette.common.layout.offWhite,
  width: "100%"
}));

export const StyledButtonContainer = styled(Grid)(({ theme }) => ({
  marginTop: theme.spacing(3),
  marginBottom: theme.spacing(3)
}));

export const StyledDataContainer = styled("div")(({ theme }) => ({
  position: "fixed",
  top: theme.spacing(35),
  right: theme.spacing(16),
  bottom: theme.spacing(10),
  left: theme.spacing(14),
  overflow: "auto"
}));

export const StyledItem = styled("div")(({ theme }) => ({
  backgroundColor: theme.palette.common.background.main,
  width: "90%",
  margin: theme.spacing(0.5),
  paddingLeft: theme.spacing(1)
}));

export const StyledAction = styled("div")(({ theme }) => ({
  float: "right",
  marginRight: theme.spacing(1),
  cursor: "pointer"
}));

export const StyledSpacer = styled("div")(({ theme }) => ({
  marginTop: theme.spacing(0.5)
}));
